export const environment = {
  firebase: {
      apiKey: "AIzaSyBz9v5vCSZprHAidm2HtTHgXJJ-Sdfvozo",
      authDomain: "les-signaleurs-du-nord-staging.firebaseapp.com",
      projectId: "les-signaleurs-du-nord-staging",
      storageBucket: "les-signaleurs-du-nord-staging.appspot.com",
      messagingSenderId: "460049863901",
      appId: "1:460049863901:web:4d35f342f5f6e375daf734",
      measurementId: "G-SW3ELLE0GN"
    },
    production: false,
    url: {
      cloudFunction: {
        gen2UrlId: 'itxwhvhw2a',
        localUrl: 'http://10.10.10.193:8080/' //'http://10.10.10.29:8080/' //'http://localhost:8080/' // 'http://10.10.10.29:8080/'
      },
    }
};
